const $toggleItems = $('.m-block--toggle-item');
const toggleTitleClass = "m-block--toggle-title";
const toggleContentClass = "m-block__wrap";
const $win = $(window);

$toggleItems.each(function forEachSection() {
  const $this = $(this);

  // hide all content sections
  $this
    .find("." + toggleContentClass)
    .hide();

});

$('.' + toggleTitleClass).on('click', onAccordionTitleClick);

function onAccordionTitleClick() {
  var $that = $(this).hasClass(`${toggleTitleClass}--opened`);
  $('.' + toggleTitleClass).removeClass(`${toggleTitleClass}--opened`).next().slideUp(200);
  if (!$that){
    $(this)
      .toggleClass(`${toggleTitleClass}--opened`)
      // resize is required for responsive
      .next().slideToggle(200, () => { $win.trigger('resize'); });
  }
}
